import styled from 'styled-components';

export const StyledCount = styled.div`
  padding: 0.5rem 0 0.5rem 1rem;
`;
